import { Button, Modal } from 'antd';
import styled from 'styled-components';

export const Container = styled.section`
  font-family: 'Work Sans', Arial, Helvetica, sans-serif;

  & > header {
    padding: 1.5rem;
    background-color: ${({ theme }) => theme.colors.white};

    & > div {
      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        max-width: ${({ theme }) => theme.breakpoints.laptopL};
      }
    }

    & > .title {
      font-weight: 700;
      margin-bottom: 1.125rem;
      font-size: 1.625rem;
    }

    & > span {
      font-size: 1rem;
    }
  }

  & .cards {
    width: 100%;
    padding: 1.5rem 0;
    background-color: #efefef;

    & > .subtitle-cards {
      margin: 1.5rem;
      margin-top: 0;
    }

    & .cards-container {
      display: flex;
      flex-wrap: wrap;
      row-gap: 1rem;
      column-gap: 1.5rem;
      width: 97%;
      margin: 1rem 1.5rem 1.5rem 1.5rem;

      & .cards-container:last-child {
        column-gap: 0;
      }

      & > .card {
        width: 100%;
        min-height: 15rem;
        max-width: 16.875rem;

        & > .hefesto-card {
          height: 100%;

          & > .hefesto-card-text-buttons {
            display: flex;
            flex-direction: column;
            height: 100%;

            & > .hefesto-title {
              margin-right: 0.5rem;
              margin-bottom: 0.313rem;
              & > h4 {
                margin: 0px;
              }
            }
            & > .hefesto-card-text-buttons__description {
              flex-grow: 1;
              margin-top: 0rem;
              margin-right: 0.5rem;
            }
            & > .hefesto-card-text-buttons__actions {
              & > .hefesto-button {
                padding-inline: 0px;
              }
            }
          }
        }
      }

      p {
        min-height: 75px;
      }

      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        max-width: ${({ theme }) => theme.breakpoints.laptopL};

        & > .card {
          max-width: 94%;
        }
      }

      @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        flex-wrap: nowrap;
        column-gap: 1.5rem;

        & > .card {
          width: 50%;
        }
      }
    }
  }
`;

export const SteelTypeCard = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  min-height: 15rem;
  padding: 1rem;
  border-radius: 6px;
  box-shadow: ${({ theme }) => theme.commoms.boxShadow};
  border: 1.5px solid ${({ theme }) => theme.colors.gray6};
  margin-bottom: 1.5rem;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    max-width: 22.75rem;

    &:first-child {
      margin-right: 1.5rem;
    }
  }

  & > header {
    & > h3 {
      font-size: 1.25rem;
      font-weight: 600;
      color: ${({ theme }) => theme.colors.blue};
    }

    & > span {
      font-size: 0.875rem;
      color: ${({ theme }) => theme.colors.grayDark2};
    }
  }
`;

export const OrderInProgressAlert = styled.span`
  /* display: flex;*/
  align-items: center;
  color: ${({ theme }) => theme.colors.purple2};
  margin: 0.25rem 0;
  height: 1rem;

  & > span svg {
    height: 1rem;
    width: 2rem;
  }
`;

export const SteelTypeChooseButton = styled(Button)`
  width: 100%;
  height: 3.125rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.grayDark2};

  &:hover {
    color: ${({ theme }) => theme.colors.white};
    background-color: ${({ theme }) => theme.colors.blue};
  }
`;

export const OrderInProgressModal = styled(Modal)`
  & .ant-modal-header {
    border-bottom: none;

    & > div {
      font-size: 1.25rem;
      color: ${({ theme }) => theme.colors.grayDark2};
    }
  }

  & .ant-modal-body {
    padding: 0 1.5rem 0.5rem;
    & > span {
      font-size: 1rem;
      color: ${({ theme }) => theme.colors.grayDark2};
    }
  }

  & .ant-modal-footer {
    border-top: none;
  }
`;
